export default "__VITE_ASSET__Bl$6QgP6__"